export default "__VITE_ASSET__8ZKGXvHq__"